const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/png',
  'image/jpeg',
];
const ALLOWED_FILE_EXTENSIONS = ['.pdf', '.doc', '.docx', '.png', '.jpg', '.jpeg'];
const MAX_FILE_SIZE_MB = 3;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export type FileValidationError = {
  type: 'invalid_type' | 'file_too_large';
  message: string;
};

export const validateFile = (file: File): FileValidationError | null => {
  // Check file type by MIME type and extension
  const extension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
  const isValidType = ALLOWED_FILE_TYPES.includes(file.type) || ALLOWED_FILE_EXTENSIONS.includes(extension);

  if (!isValidType) {
    return {
      type: 'invalid_type',
      message: `Invalid file type. Allowed types: ${ALLOWED_FILE_EXTENSIONS.join(', ')}`,
    };
  }

  // Check file size
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return {
      type: 'file_too_large',
      message: `File size exceeds ${MAX_FILE_SIZE_MB}MB limit. Your file is ${(file.size / 1024 / 1024).toFixed(2)}MB.`,
    };
  }

  return null;
};

export const getFileDisplayName = (file: File): string => {
  return file.name;
};
